import api from '@/api'

export default {
    saveCardContent(cardContent: string, cardType: string, isMobile?: boolean): Promise<string> {
        return api.post({
            url: `/KyoboBook/Home/api/saveContent`,
            data: {
                html: cardContent,
                cardType: cardType,
                isMobile: isMobile
            }
        })
    },

    getUserBarcode(): Promise<string>{
        return api.get({
            url: `/KyoboBook/Home/api/getBarcode`
        })
    }
}